<template>
  <div>
    <a-spin :spinning="fetchingFull">
      <div class="row">
        <div class="col-md-12">
          <h3>Advanced Filter </h3>
        </div>
      </div>

      <div class="row align-items-center">
        <div class="col-md-6">
          <base-input label="Design">
            <a-select v-model="inputDesign" showSearch placeholder="All Designs" style="width: 100%" :filterOption="filterOption">
              <a-select-option v-for="option in designOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
            </a-select>
          </base-input>
        </div>

        <div class="col-md-6">
          <base-input label="Color">
            <a-select v-model="inputColor" showSearch placeholder="All Colors" style="width: 100%" :filterOption="filterOption">
              <a-select-option v-for="option in colorOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
            </a-select>
          </base-input>
        </div>

        <div class="col-md-6">
          <base-input label="Size">
            <a-select v-model="inputSize" showSearch placeholder="All Sizes" style="width: 100%" :filterOption="filterOption">
              <a-select-option v-for="option in sizeOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
            </a-select>
          </base-input>
        </div>

        <div class="col-md-6">
          <base-input label="Product Line">
            <a-select v-model="inputProductLine" showSearch placeholder="All Product Lines" style="width: 100%" :filterOption="filterOption">
              <a-select-option v-for="option in productLineOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
            </a-select>
          </base-input>
        </div>

        <div class="col-md-6">
          <base-input label="Product Type">
            <a-select v-model="inputProductType" showSearch placeholder="All Product Types" style="width: 100%" :filterOption="filterOption">
              <a-select-option v-for="option in productTypeOptions" :key="option.key" :value="option.key">{{option.value}}</a-select-option>
            </a-select>
          </base-input>
        </div>

        <div class="col-md-6">
          <base-input label="Supplier Type">
            <a-select v-model="inputSupplierType" showSearch placeholder="All Supplier Types" style="width: 100%" :filterOption="filterOption">
              <a-select-option v-for="option in supplierTypeOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
            </a-select>
          </base-input>
        </div>

        <div class="col-md-6">
          <base-input label="VAT">
            <a-select v-model="inputTaxType" showSearch placeholder="All Tax Type" style="width: 100%" :filterOption="filterOption">
              <a-select-option v-for="option in taxTypeOptions" :key="option.key" :value="option.key">{{option.value}}</a-select-option>
            </a-select>
          </base-input>
        </div>

        <div class="col-md-12">
          <base-input label="Barcode" v-model="inputBarcode" />
        </div>

        <div class="col-md-6">
          <base-input label="Stock #" v-model="inputStockNo" />
        </div>

        <div class="col-md-12">
          <base-input label="Name" v-model="inputName" />
        </div>

        <div class="col-md-12">
          <div class="row">
            <div class="col-md-4">
              <base-input label="Retail Price">
                <br>
                <a-select v-model="inputRetailPriceOperator" showSearch placeholder="All Prices" optionFilterProp="children" style="width: 100%" :filterOption="false">
                  <a-select-option value="">All Prices</a-select-option>
                  <a-select-option value="=">=</a-select-option>
                  <a-select-option value="<>">&lt;&gt;</a-select-option>
                  <a-select-option value=">">&gt;</a-select-option>
                  <a-select-option value="<">&lt;</a-select-option>
                  <a-select-option value=">=">&gt;=</a-select-option>
                  <a-select-option value="<=">&lt;=</a-select-option>
                  <a-select-option value="like">END WITH</a-select-option>
                  <a-select-option value="between">BETWEEN</a-select-option>
                </a-select>
              </base-input>
            </div>

            <div class="col-md-8">
              <br>
              <base-input v-if="inputRetailPriceOperator != ''" class="pt-2" v-model="inputRetailPrice" />
              <base-input v-if="inputRetailPriceOperator == 'between'" v-model="inputRetailPrice2" />
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <base-input label="Status">
            <a-select mode="multiple" v-model="inputStatus" style="width: 100%" placeholder="All Status"
              optionFilterProp="children">
              <a-select-option value="A">Active</a-select-option>
              <a-select-option value="I">Inactive</a-select-option>
              <a-select-option value="P">Phase Out</a-select-option>
            </a-select>
          </base-input>
        </div>

        <div class="col-md-12">
          <base-input label="Category">
            <br>
            <a-cascader v-model="inputCategory" :options="categoriesOptions" :showSearch="{filter}"
              placeholder="All Categories" style="width: 100%" changeOnSelect />
          </base-input>
        </div>
        
        <div class="col-md-12">
          <base-input label="Supplier">
            <br>
            <a-select mode="multiple" v-model="inputSupplier" style="width: 100%" placeholder="All Suppliers" :filterOption="false"
              :notFoundContent="fetching ? undefined : null" @search="handleSearchSupplier">
              <a-spin v-if="fetching" slot="notFoundContent" size="small" />
              <a-select-option v-for="option in supplierOptions" :key="option.id" :value="option.id">{{option.name}}
              </a-select-option>
            </a-select>
          </base-input>
        </div>

        <div class="col-md-12">
          <base-input label="Brand">
            <br>
            <a-select mode="multiple" v-model="inputBrand" style="width: 100%" placeholder="All Brands" :filterOption="false"
              :notFoundContent="fetching ? undefined : null" @search="handleSearch">
              <a-spin v-if="fetching" slot="notFoundContent" size="small" />
              <a-select-option v-for="option in brandOptions" :key="option.id" :value="option.id">{{option.name}}
              </a-select-option>
            </a-select>
          </base-input>
          <br><br>
        </div>
      </div> <!-- end <div class="row align-items-center"> -->
    </a-spin>

    <div style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
      <button class="btn btn-sm btn-primary float-right" style="width: 30%;" @click.prevent="updateParams"> Apply
      </button>
      <button class="btn btn-sm float-right"
        style="background-color: #394A5D; color: white; width: 30%; margin-right: 5%" @click.prevent="clearFilter">
        Clear </button>
    </div>
  </div>
</template>
<script>
  import HTTPRequest from '../../controllers/httpRequest.js'
  import {
    mapState
  } from 'vuex'

  export default {
    data: function () {
      return {
        fetching: false,
        fetchingFull: false,
        inputCategory: null,
        categoryOptions: [],
        inputBrand: [],
        brandOptions: [],
        inputStatus: [],
        inputSupplier: [],
        supplierOptions: [],
        inputDesign: [],
        designOptions: [],
        inputColor: [],
        colorOptions: [],
        inputSize: [],
        sizeOptions: [],
        inputTaxType: [],
        taxTypeOptions: [
          { key: 'V', value: 'VAT'},
          { key: 'N', value: 'Non-VAT'}
        ],
        inputProductLine: [],
        productLineOptions: [],
        inputSupplierType: [],
        supplierTypeOptions: [],
        inputProductType: [],
        productTypeOptions: [
          { key: 'R', value: 'Regular'},
          { key: 'P', value: 'Package'},
          { key: 'M', value: 'Matrix'},
          { key: 'I', value: 'Matrix Item'},
          { key: 'N', value: 'Non-Inventory'},
          { key: 'S', value: 'Serial Item'},
          { key: 'K', value: 'Kit'},
          { key: 'V', value: 'Virtual Kit'}
        ],
        inputBarcode: null,
        inputStockNo: null,
        inputName: null,
        inputRetailPrice: null,
        inputRetailPrice2: '',
        inputRetailPriceOperator: ''
      }
    },
    computed: {
      ...mapState(['endPoint', 'categoriesOptions'])
    },
    mounted: async function () {
      this.fetchingFull = true

      var component_x = this;

      var designs = await HTTPRequest.getRequest(component_x.endPoint + "designs/get_valid_designs", null);
      component_x.designOptions = designs;
      component_x.sort(component_x.designOptions);

      var colors = await HTTPRequest.getRequest(component_x.endPoint + "colors/get_valid_colors", null);
      component_x.colorOptions = colors;
      component_x.sort(component_x.colorOptions);

      var sizes = await HTTPRequest.getRequest(component_x.endPoint + "sizes/get_valid_sizes", null);
      component_x.sizeOptions = sizes;
      component_x.sort(component_x.sizeOptions);

      var product_lines = await HTTPRequest.getRequest(component_x.endPoint + "product_lines/get_valid_product_lines", null);
      if(product_lines != null){
        component_x.productLineOptions = product_lines;
        component_x.sort(component_x.productLineOptions);
      }

      var supplier_types = await HTTPRequest.getRequest(component_x.endPoint + "supplier_types/get_valid_supplier_types", null);
      component_x.supplierTypeOptions = supplier_types;
      component_x.sort(component_x.supplierTypeOptions);
      console.log(this.$attrs.parentParams)
      var originalParameters = this.$attrs.parentParams;
      if(originalParameters.inputDesign != undefined){
        this.inputDesign = originalParameters.inputDesign
      }

      if(originalParameters.inputColor != undefined){
        this.inputColor = originalParameters.inputColor
      }

      if(originalParameters.inputSize != undefined){
        this.inputSize = originalParameters.inputSize
      }

      if(originalParameters.inputProductLine != undefined){
        this.inputProductLine = originalParameters.inputProductLine
      }

      if(originalParameters.inputProductType != undefined){
        this.inputProductType = originalParameters.inputProductType
      }

      if(originalParameters.inputSupplierType != undefined){
        this.inputSupplierType = originalParameters.inputSupplierType
      }

      if(originalParameters.inputTaxType != undefined){
        this.inputTaxType = originalParameters.inputTaxType
      }

      if(originalParameters.inputStockNo != undefined){
        this.inputStockNo = originalParameters.inputStockNo
      }

      if(originalParameters.inputName != undefined){
        this.inputName = originalParameters.inputName
      }

      if(originalParameters.inputBarcode != undefined){
        this.inputBarcode = originalParameters.inputBarcode
      }
      
      if(originalParameters.inputRetailPrice != undefined){
        this.inputRetailPrice = originalParameters.inputRetailPrice
        this.inputRetailPrice2 = originalParameters.inputRetailPrice2
        this.inputRetailPriceOperator = originalParameters.inputRetailPriceOperator
      }

      if(originalParameters.inputStatus != undefined){
        this.inputStatus = originalParameters.inputStatus
      }

      if(originalParameters.inputCategory != undefined){
        this.inputCategory = originalParameters.inputCategory
      }

      if(originalParameters.inputSupplier != undefined){
        this.inputSupplier = originalParameters.inputSupplier
      }

      //Populate selected brands
      if(originalParameters.inputBrand != undefined){
        var iBrands = []
        let i = 0;
        let len = originalParameters.inputBrand.length;
        for (; i < len; ) {
          var brands = await HTTPRequest.getRequest(component_x.endPoint + "brands/get_valid_brands?id=" + originalParameters.inputBrand[i], null, null)
          iBrands.push(brands[0])
          i++;
        }
        component_x.brandOptions = iBrands;
        component_x.sort(component_x.brandOptions);
        this.inputBrand = originalParameters.inputBrand
      }
      this.fetchingFull = false
    },
    methods: {
      updateParams() {
        var actualParams = {
          inputDesign: this.inputDesign,
          inputColor: this.inputColor,
          inputSize: this.inputSize,
          inputProductLine: this.inputProductLine,
          inputProductType: this.inputProductType,
          inputSupplierType: this.inputSupplierType,
          inputTaxType: this.inputTaxType,
          inputStockNo: this.inputStockNo,
          inputName: this.inputName,
          inputBarcode: this.inputBarcode,
          inputRetailPrice: this.inputRetailPrice,
          inputRetailPriceOperator: this.inputRetailPriceOperator,
          inputRetailPrice2: this.inputRetailPrice2,
          inputStatus: this.inputStatus,
          inputCategory: this.inputCategory,
          inputSupplier: this.inputSupplier,
          inputBrand: this.inputBrand
        }

        if(this.inputDesign.length != 0){
          Object.assign(actualParams, {
            design_name: this.designOptions.find(x => x.id === this.inputDesign).name
          });
        }

        if(this.inputColor.length != 0){
          Object.assign(actualParams, {
            color_name: this.colorOptions.find(x => x.id === this.inputColor).name
          });
        }

        if(this.inputSize.length != 0){
          Object.assign(actualParams, {
            size_name: this.sizeOptions.find(x => x.id === this.inputSize).name
          });
        }

        if(this.inputProductLine.length != 0){
          Object.assign(actualParams, {
            product_line_name: this.productLineOptions.find(x => x.id === this.inputProductLine).name
          });
        }

        if(this.inputProductType.length != 0){
          Object.assign(actualParams, {
            product_type_name: this.productTypeOptions.find(x => x.key === this.inputProductType).value
          });
        }
        
        if(this.inputTaxType.length != 0){
          Object.assign(actualParams, {
            tax_type_name: this.taxTypeOptions.find(x => x.key === this.inputTaxType).value
          });
        }

        if(this.inputSupplierType.length != 0){
          Object.assign(actualParams, {
            supplier_type_name: this.supplierTypeOptions.find(x => x.id === this.inputSupplierType).name
          });
        }

        var retail = ""
        if(this.inputRetailPriceOperator != ''){
          if(this.inputRetailPriceOperator == 'between'){
            retail = this.inputRetailPriceOperator + ' ' + this.inputRetailPrice + ' and ' + this.inputRetailPrice2 
          }else if(this.inputRetailPriceOperator == 'like'){
            retail = this.inputRetailPriceOperator + ',' + this.inputRetailPrice 
          }else {
            retail = this.inputRetailPriceOperator + ' ' + this.inputRetailPrice
          }
        }

        var childParams = {
          design_id: this.inputDesign,
          color_id: this.inputColor,
          size_id: this.inputSize,
          product_line_id: this.inputProductLine,
          product_type: this.inputProductType,
          supplier_type_id: this.inputSupplierType,
          tax_type: this.inputTaxType,
          stock_no: this.inputStockNo,
          name: this.inputName,
          barcode: this.inputBarcode,
          retail_price: retail,
          status: this.inputStatus,
          supplier_id: this.inputSupplier,
          brand_id: this.inputBrand
        }

        if(this.inputCategory != null && this.inputCategory != "" && this.inputCategory != "0"){
          var resultLength = this.inputCategory.length
          switch(resultLength) {
            case 5:
              childParams.category_id = this.inputCategory[4];
              break;
            case 4:
              childParams.section_id = this.inputCategory[3];
              break;
            case 3:
              childParams.department_id = this.inputCategory[2];
              break;
            case 2:
              childParams.division_id = this.inputCategory[1];
              break;
          }
        }

        this.$emit('changeParams', childParams, actualParams, 'filter')
      },
      clearFilter(){
        this.inputDesign = []
        this.inputColor = []
        this.inputSize = []
        this.inputProductLine = []
        this.inputProductType = []
        this.inputSupplierType = []
        this.inputTaxType = []
        this.inputStockNo = null
        this.inputName = null
        this.inputBarcode = null
        this.inputRetailPrice = null
        this.inputRetailPriceOperator = ''
        this.inputRetailPrice2 = ''
        this.inputStatus = []
        this.inputCategory = null
        this.inputSupplier = []
        this.inputBrand = []

        this.$emit('changeParams', {}, {}, 'clear')
      },
      filterOption(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
      sort(data){
        data.sort(function (a, b) {
          return a.name.localeCompare(b.name);
        });
      },
      async filter(inputValue) {
        if (inputValue.length >= 3) {
          this.categoryOptions = await HTTPRequest.getRequest(this.endPoint + 'categories/cascader_view?name=' + inputValue, null);
        }
      },
      async handleSearch(value) {
        this.fetching = true;
        var brands = await HTTPRequest.getRequest(this.endPoint + "brands/get_valid_brands?name=" + value, null,
          null)
        this.brandOptions = brands
        this.sort(this.brandOptions)
        this.fetching = false;
      },
      async handleSearchSupplier(value) {
        this.fetching = true;
        var suppliers = await HTTPRequest.getRequest(this.endPoint + "suppliers/get_valid_suppliers?name=" + value, null,
          null)
        this.supplierOptions = suppliers
        this.sort(this.supplierOptions)
        this.fetching = false;
      },
    }
  }
</script>
<style scoped>

</style>